'use client';

import React, { useEffect, useRef, useState } from 'react';
import { motion, useAnimation } from 'framer-motion';

type HorizontalRevealProps = {
  children: JSX.Element;
  direction?: 'left' | 'right';
  offset?: number;
  delay?: number;
};

export default function HorizontalReveal({
  children,
  direction = 'left',
  offset = 100, // Начальное смещение
  delay = 0.25 // Задержка по умолчанию, аналогичная вашему примеру
}: HorizontalRevealProps) {
  const controls = useAnimation();
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handleScroll = () => {
      if (ref.current) {
        const rect = ref.current.getBoundingClientRect();
        if (rect.top >= 0 && rect.top <= window.innerHeight) {
          setIsVisible(true);
        }
      }
    };

    handleScroll(); // Проверить видимость сразу при монтировании
    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (isVisible) {
      controls.start({
        x: 0,
        opacity: 1,
        transition: {
          type: 'spring',
          stiffness: 60, // Уменьшенная жесткость для плавности
          damping: 20,
          duration: 2.5, // Увеличенная длительность в 3 раза
          delay: delay // Добавили возможность задать задержку
        }
      });
    }
  }, [isVisible, controls, delay]);

  const initialX = direction === 'left' ? -offset : offset;

  return (
    <motion.div ref={ref} initial={{ x: initialX, opacity: 0 }} animate={controls}>
      {children}
    </motion.div>
  );
}
